// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BillsChartsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.BillFilter>;
}>;


export type BillsChartsQuery = { __typename?: 'Query', billMetrics?: { __typename?: 'BillMetricsResult', totalOpenPayables: number, totalAgingOfPayables: number, totalAwaitingApprovals: number, openPayables: Array<{ __typename?: 'BillMetric', label: string, totalAmount?: any | null | undefined }>, agingOfPayables: Array<{ __typename?: 'BillMetric', label: string, totalAmount?: any | null | undefined }>, awaitingApprovals: Array<{ __typename?: 'BillMetric', label: string, totalAmount?: any | null | undefined }> } | null | undefined };


export const BillsChartsDocument = gql`
    query BillsCharts($filter: BillFilter) {
  billMetrics(filter: $filter) {
    openPayables {
      label
      totalAmount
    }
    totalOpenPayables
    agingOfPayables {
      label
      totalAmount
    }
    totalAgingOfPayables
    awaitingApprovals {
      label
      totalAmount
    }
    totalAwaitingApprovals
  }
}
    `;

/**
 * __useBillsChartsQuery__
 *
 * To run a query within a React component, call `useBillsChartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillsChartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillsChartsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBillsChartsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BillsChartsQuery, BillsChartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BillsChartsQuery, BillsChartsQueryVariables>(BillsChartsDocument, options);
      }
export function useBillsChartsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BillsChartsQuery, BillsChartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BillsChartsQuery, BillsChartsQueryVariables>(BillsChartsDocument, options);
        }
export function useBillsChartsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillsChartsQuery, BillsChartsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BillsChartsQuery, BillsChartsQueryVariables>(BillsChartsDocument, options);
        }
export type BillsChartsQueryHookResult = ReturnType<typeof useBillsChartsQuery>;
export type BillsChartsLazyQueryHookResult = ReturnType<typeof useBillsChartsLazyQuery>;
export type BillsChartsSuspenseQueryHookResult = ReturnType<typeof useBillsChartsSuspenseQuery>;
export type BillsChartsQueryResult = Apollo.QueryResult<BillsChartsQuery, BillsChartsQueryVariables>;